document.addEventListener("DOMContentLoaded", (event) => {
  const sntapForm = document.querySelector("#ContactEmailForm:has(#bss_newletter_input)");
  sntapForm.addEventListener('submit', e => {
    e.preventDefault();
  })
});

const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  const sntapInputs = document.querySelectorAll("#NewsletterFormCustom, #Bss-NewsletterFormCustom");
  if(sntapInputs) {
    sntapInputs.forEach(sntapInput => {
      if (sntapInput && sntapInput.placeholder !== 'Subscribe for savings') {
        sntapInput.placeholder = 'Subscribe for savings'
      }
      const submitBtn = document.querySelector('.field #Subscribe');
      if (submitBtn && submitBtn.innerHTML !== 'Subscribe') {
        submitBtn.innerHTML = 'Subscribe'
      }
    });
  }
};

const observer = new MutationObserver(callback);

observer.observe(document.body, config);


